import { UserRole } from "../../enums/UserRole";
import { API_ROUTES } from "../apiRoutes";
import axiosInstance from "../axiosInstance";

const SELLER_URL = API_ROUTES.AUTH;
const ADMIN_URL = API_ROUTES.ADMIN;

export const loginUser = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`${SELLER_URL}/login`, payload);
    return response.data.data;
  } catch (error) {
    console.error("Error logining user:", error);
    throw error;
  }
};

export const registerUser = async (userType: string, payload: any) => {
  if (userType.toLowerCase() === UserRole.SELLER) {
    return registerSeller(payload);
  } else if (userType.toLowerCase() === UserRole.ADMIN) {
    return registerAdmin(payload);
  }
};

export const registerSeller = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${API_ROUTES.SELLER}/register`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

export const registerAdmin = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`${ADMIN_URL}/register`, payload);
    return response.data.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

export const getForgotPasswordLink = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${SELLER_URL}/forgot-password`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const resetForgotPassword = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${SELLER_URL}/reset-password`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const updatePassword = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${SELLER_URL}/update-password`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const verifyEmail = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${SELLER_URL}/verify-email`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};
